




















import { Vue, Component, Watch } from 'vue-property-decorator';
import { TranslateResult } from 'vue-i18n';
import { sleep } from '@/utils';

@Component({name: 'app-snackbar'})
export default class extends Vue {

  private duration: number = 0;
  private visible: boolean = false;
  private fadeout: boolean = false;
  private message: string | TranslateResult = '';
  private status: 'error' | 'warn' | 'info' = 'info';

  public created(): void {
    this.setDuration(3000);
  }

  @Watch('visible')
  private onVisible(visible): void {
    if (visible === true) {
      this.hideWithDelay();
    }
  }

  private setDuration(ms: number): void {
    this.duration = ms;
  }
  private info(message: string | TranslateResult): void {
    this.status = 'info';
    this.show(message);
  }
  private warning(message: string | TranslateResult): void {
    this.status = 'warn';
    this.show(message);
  }
  private error(message: string | TranslateResult): void {
    this.status = 'error';
    this.show(message);
  }
  private show(message: string | TranslateResult, duration?: number): void {
    (duration !== undefined) && this.setDuration(duration);
    this.message = message;
    this.visible = true;
  }
  private async hideWithDelay(): Promise<void> {
    await sleep(this.duration || 300000); // or 5 minutes, kinda "endless"
    this.fadeout = true;
    await sleep(480);
    this.visible = false;
    this.fadeout = false;
  }

}
